import { Space, Text } from '@procurify/ui'

import { FormattedShortDate } from '@webapp/core/components/FormattedDate'
import { useProcurifyIntl } from '@webapp/hooks'
import { type ReconcileMatch } from '@webapp/modules/accounts-payable/entities/ReconcileMatch'
import messages from './messages'

export interface IMatchedStatementItemsListProps {
  /** Content source — no fetch; the ModalDialog + confirm/cancel are FS-owned (BHV-040) */
  match: ReconcileMatch
}

export const MatchedStatementItemsList = ({
  match,
}: IMatchedStatementItemsListProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Text autoMargin={false}>{intl.formatMessage(messages.description)}</Text>
      <Space size='small'>
        {match.statementItems.map((item) => (
          <Space
            key={item.id}
            direction='horizontal'
            justify='space-between'
            align='center'
          >
            <Text bold autoMargin={false}>
              {item.description}
            </Text>
            <Space direction='horizontal' align='center'>
              <Text autoMargin={false}>
                <FormattedShortDate date={new Date(`${item.date}T00:00:00`)} />
              </Text>
              <Text bold autoMargin={false}>
                {item.amountValue.toFixed(2)}
              </Text>
            </Space>
          </Space>
        ))}
      </Space>
    </Space>
  )
}

MatchedStatementItemsList.displayName = 'MatchedStatementItemsList'
